import {useMutation} from "@tanstack/react-query";

import {removeSupplierContactMutationOptions} from "./remove-supplier-contact.mutation-options";

export function useRemoveSupplierContact(supplierId: string) {
  return useMutation(removeSupplierContactMutationOptions(supplierId));
}
